import { madSDK } from "lib/sdk";

/**
 * Origin (scheme + host, no path) for Prism, fronted by edge's
 * `/data-intelligence` route (see services/edge/hosts.go `PrismHost`).
 *
 * Derived from the seller URL because that is where environment selection
 * lives, mirroring getSellerApiHost/getMaverickApiHost. Callers append their
 * own path.
 */
export function getPrismHost(): string {
  return new URL(madSDK.urls.sellerBaseUrl).origin;
}
